import React from 'react';
import styled from 'styled-components';
import { lightGrey2Color } from 'js/config/style';

export default styled(({ disabled, color, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32.83 6.94" {...rest}>
    <circle className="ellipsis" cx="3.47" cy="3.47" r="3.47" />
    <circle className="ellipsis" cx="16.41" cy="3.47" r="3.47" />
    <circle className="ellipsis" cx="29.36" cy="3.47" r="3.47" />
  </svg>
))`
  position: relative;
  top: -1px;
  width: 1.5rem;

  .ellipsis {
    fill: ${({ disabled, color }) => color || (disabled ? lightGrey2Color : color)};
  }
`;
